import md5 from  'blueimp-md5';

angular.module('app.filters').filter('md5', () => input => md5(input));



// WEBPACK FOOTER //
// ./filters/md5.js